module.exports = __webpack_public_path__ + "76ba626e24bd49d438f268f6c6aca6fe.pdf";